import { SVGProps } from "react"

export const OneFriendIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="40rem" height="40rem" viewBox="0 0 40 40" fill="none" {...props}>
            <rect x="0.5" y="0.5" width="39" height="39" rx="19.4789" fill="url(#paint0_radial_5994_2035)" stroke="url(#paint1_linear_5994_2035)" />
            <g filter="url(#filter0_d_5994_2035)">
                <circle cx="11.9707" cy="11.9707" r="3.05407" fill="white" />
                <circle cx="27.6123" cy="11.9707" r="3.05407" fill="white" />
            </g>
            <g filter="url(#filter1_d_5994_2035)">
                <path d="M18 15C18 16.1046 18.8954 17 20 17C21.1046 17 22 16.1046 22 15" stroke="white" strokeLinecap="round" />
            </g>
            <defs>
                <filter id="filter0_d_5994_2035" x="6.56066" y="6.56066" width="26.4617" height="10.8202" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.178" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5994_2035" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5994_2035" result="shape" />
                </filter>
                <filter id="filter1_d_5994_2035" x="15.144" y="12.144" width="9.712" height="7.712" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="1.178" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5994_2035" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5994_2035" result="shape" />
                </filter>
                <radialGradient id="paint0_radial_5994_2035" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20 19) rotate(90) scale(20)">
                    <stop stopColor="#D9D9D9" stopOpacity="0.68" />
                    <stop offset="1" stopColor="#737373" stopOpacity="0" />
                </radialGradient>
                <linearGradient id="paint1_linear_5994_2035" x1="20" y1="1" x2="20" y2="39" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#999999" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>

    )
}